import cn from 'classnames'
import React from 'react'

import { IS_MAC } from 'constants/commonConstans'

import * as s from './KeyBindTag.module.scss'

type PreTypedButtons =
  | 'shift'
  | 'ctrl'
  | 'alt'
  | 'up'
  | 'down'
  | 'left'
  | 'right'
  | 'backspace'
  | 'delete'
  | 'mouseLeft'

const KEY_DISPLAY_MAP: Record<string, string> = {
  shift: IS_MAC ? '⇧' : '⇧',
  ctrl: IS_MAC ? '⌘' : 'Ctrl',
  alt: IS_MAC ? '⌥' : 'Alt',
  delete: IS_MAC ? 'delete' : 'DEL',
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
  backspace: 'Backspace',
  mouseLeft: 'LMB',
}
const KEYS = Object.keys(KEY_DISPLAY_MAP).sort((a, b) => b.length - a.length)
const REGEX = new RegExp(`(${KEYS.join('|')})`, 'g')

interface IKeyBindTagProps {
  onClick?: () => void
  bind:
    | `${PreTypedButtons}+${string}`
    | `${PreTypedButtons}|${PreTypedButtons}`
    | `${PreTypedButtons}|${PreTypedButtons}|${PreTypedButtons}|${PreTypedButtons}`
  dark?: boolean
}

const KeyBindTag: React.FC<IKeyBindTagProps> = ({ bind, dark, onClick }) => {
  const parts = bind
    .replace(/\+/g, ' + ')
    .replace(REGEX, (match, key) => (key ? KEY_DISPLAY_MAP[key] : match))
    .split('|')

  return (
    <div className={s.root}>
      {parts.map((part) => (
        <div
          className={cn(s.part, { [s.active]: Boolean(onClick), [s.dark]: dark })}
          key={part}
          onClick={onClick}
        >
          {part}
        </div>
      ))}
    </div>
  )
}

export default React.memo(KeyBindTag)
